var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"actions-item",attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.favoriteClicked()}}},[_c('span',{class:_vm.favoriteClass})])}
var staticRenderFns = []

export { render, staticRenderFns }